import React from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import type { Amil } from "../store/api";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      marginTop: theme.spacing(3),
      overflowX: "auto",
    },
    table: {
      minWidth: 700,
    },
  })
);

interface Props {
  amil: Amil;
  onClose: () => void;
}

function AmilProfile({ amil, onClose }: Props) {
  const classes = useStyles();

  //   console.log(amil.data);
  //   const data = amil.data ? JSON.parse(amil.data) : {};

  //   let extras = [];
  //   for (let [key, value] of data.entries()) {
  //     const row = (
  //       <TableRow key={key}>
  //         <TableCell>{key}</TableCell>
  //         <TableCell>{value}</TableCell>
  //       </TableRow>
  //     );

  //     extras.push(row);
  //   }

  return (
    <>
      <div style={{ float: "left", marginRight: 20 }}>
        <IconButton onClick={onClose}>
          <ArrowBackIcon />
        </IconButton>
      </div>

      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableBody>
            <TableRow>
              <TableCell>Nama</TableCell>
              <TableCell>{amil.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>No KP</TableCell>
              <TableCell>{amil.ic}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Kariah</TableCell>
              <TableCell>
                {amil.kariah_code} - {amil.kariah_name}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Perbadanan</TableCell>
              <TableCell>{amil.body}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Kod QR</TableCell>
              <TableCell>{amil.code}</TableCell>
            </TableRow>
            {/* {extras} */}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}

export default AmilProfile;
